<template>
  <section class="register">
    <div class="box">
      <div class="header">
        <div key="info" class="title">Informação</div>
        <div @click="$router.push('/signature')" class="close"><i class="fas fa-times"></i></div>
      </div>
      <form @submit.prevent class="form">
        <Selector v-model="active" :options="activeOptions" class="selector_change"/>
        <!-- <label class="switch">
          <input v-model="active" type="checkbox">
          <span class="slider"></span>
          <span class="text">{{ this.active ? 'Assinatura ativada' : 'Assinatura desativada' }}</span>
        </label> -->
        <!-- Nome -->
        <label>Nome</label>
        <input v-model="user" :disabled="true" type="text" placeholder="Nome do cliente" :class="{ error : error.includes('name') }" />
        <div v-if="error.indexOf('user') > -1" class="hint">você esqueceu de digitar o nome</div>
        <!-- Nome -->
        <label>Produto</label>
        <input v-model="product" :disabled="true" type="text" placeholder="Nome do produto" :class="{ error : error.includes('name') }" />
        <div v-if="error.indexOf('product') > -1" class="hint">você esqueceu de digitar o nome</div>
        <!--Preço -->
        <label>Preço</label>
        <!-- <input v-model="price" type="text" placeholder="Preço do produto" :class="{ error : error.includes('desc') }" /> -->
        <money v-bind="formatMoney" :disabled="true" v-model="price" :class="{ error : error.indexOf('price') > -1 }"></money>
        <div v-if="error.includes('price')" class="hint">você esqueceu de digitar o preço</div>
        <!-- Validade -->
        <label>Mensalidade</label>
        <input v-model="nextDate" v-on:keydown="validade" type="date" :min="(new Date()).toISOString().split('T')[0]" :class="{ error : error.indexOf('expiration') > -1 }"/>
        <div v-if="error.indexOf('nextDate') > -1" class="hint">Mensalidade inválida</div>
        <label>Renovar por mais</label>
        <select v-model="period" :change="changeDate()">
          <option value="null">Selecione o período</option>
          <option value="30">1 mês</option>
          <option value="90">3 meses</option>
          <option value="180">6 meses</option>
          <option value="360">1 ano</option>
        </select>
        <div v-if="error.indexOf('period') > -1" class="hint">Período inválido</div>
        <label class="switch">
          <input v-model="change" type="checkbox">
          <span class="slider"></span>
          <span class="text">Alterar Produto</span>
        </label>
        <label v-if="change">Novo Produto</label>
        <select v-if="change" v-model="newProduct">
          <option value="null">Selecione o produto</option>
          <option v-for="p in products" :key="p.id" :value="p.id">{{ p.name }}</option>
        </select>
      </form>
      <div class="actions">
        <button @click="$router.push('/signature')" class="button-previous"><i class="fas fa-angle-left"></i><span>Cancelar</span></button>
        <!-- v-if="newProduct || period || !active" -->
        <button @click="save" class="button-save"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Salvar</span></button>
      </div>
    </div>
  </section>
</template>

<script>
import logger from '../../logger'
import { update } from '../api/signature'
import Selector from './Selector'
import { getAll } from '../api/product'

export default {
  name: 'signature',
  components: { Selector },
  props: ['id', 'signatureData'],
  data () {
    return {
      loading: false,
      error: [],
      user: null,
      product: null,
      price: null,
      active: null,
      nextDate: null,
      maxDate: null,
      period: null,
      change: null,
      newProduct: null,
      products: [],
      formatMoney: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      activeOptions: [
        {
          value: true,
          text: 'ATIVA'
        },
        {
          value: false,
          text: 'INATIVA'
        }
      ]
    }
  },
  async mounted () {
    if (this.id !== 'new') {
      this.user = this.signatureData.user
      this.product = this.signatureData.product
      this.price = this.signatureData.price
      this.active = this.signatureData.active
      this.nextDate = this.signatureData.nextDate ? String(this.signatureData.nextDate).split('/')[2] + '-' + String(this.signatureData.nextDate).split('/')[1] + '-' + String(this.signatureData.nextDate).split('/')[0] : null
      this.period = null
    } else {
      this.active = true
    }
    this.products = await getAll()
  },
  methods: {
    validade (e) {
      e.preventDefault()
    },
    changeDate () {
      if (this.period) {
        let auxDate = new Date()
        auxDate = auxDate.setDate(auxDate.getDate() + Number(this.period))
        auxDate = new Date(auxDate)
        const newYear = String(auxDate.getFullYear())
        let newMonth = auxDate.getMonth() + 1
        if (newMonth < 10) {
          newMonth = '0' + String(newMonth)
        } else {
          newMonth = String(newMonth)
        }
        let newDay = auxDate.getDate()
        if (newDay < 10) {
          newDay = '0' + String(newDay)
        } else {
          newDay = String(newDay)
        }
        this.nextDate = String(newYear) + '-' + String(newMonth) + '-' + String(newDay)
      }
    },
    async save () {
      try {
        if (this.loading) return false
        this.loading = true
        this.error = []
        await update(this.id, this.price, this.period, this.newProduct, this.nextDate, this.active)
        this.loading = false
        this.$router.push('/signature')
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        } else {
          logger.error(error, this)
        }
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";
.selector_change {
    background-color: #cccccc;
    color: #595959;
    font-size: 0.8em;
    padding: 2.5px;
}
</style>
